export var dataHooks = {
  controlSearchInput: 'control-search-input',
  searchCloseButton: 'search-close-button',
  controlSearchOption: function controlSearchOption(index) {
    return "control-search-option-".concat(index);
  }
};